// File: post-video.js
// Import Cumulo
import Cumulo from '../modules/cumulo.js';
import $ from 'jquery';

class PostVideoRenderer extends Cumulo {
    onEnter() {
		$('html').addClass('alt-header');
    }
}

// Don`t forget to export your renderer
export default PostVideoRenderer;